// @flow
import * as React from 'react';
import {InlineCode} from 'docs/components';
import type {FilePurposesContextFilePurpose as FilePurposeData} from 'docs/types';
import {Table, TableHeaderCell, TableCell} from '../../core/Table/Table';

type FilePurposesProps = {|
  purposesList: Array<FilePurposeData>,
|};

const FilePurpose = (purpose: FilePurposeData) => {
  let humanReadableMaxSize;
  if (purpose.maxSize > 1000000) {
    humanReadableMaxSize = `${purpose.maxSize / 1000000}MB`;
  } else if (purpose.maxSize > 1000) {
    humanReadableMaxSize = `${purpose.maxSize / 1000}KB`;
  } else {
    humanReadableMaxSize = `${purpose.maxSize}B`;
  }

  return (
    <tr>
      <TableCell>
        <InlineCode>{purpose.name}</InlineCode>
      </TableCell>
      <TableCell>{purpose.description}</TableCell>
      <TableCell>
        {purpose.supportedMimetypes.map((mimetype) => {
          return (
            <>
              {mimetype}
              <br />
            </>
          );
        })}
      </TableCell>
      <TableCell>{humanReadableMaxSize}</TableCell>
      <TableCell>{purpose.expiry}</TableCell>
      <TableCell>{purpose.downloadable.toString()}</TableCell>
    </tr>
  );
};

export const FilePurposes = ({purposesList}: FilePurposesProps) => {
  return (
    <div className="FilePurposes">
      <Table type="striped">
        <thead>
          <tr>
            <TableHeaderCell>Purpose</TableHeaderCell>
            <TableHeaderCell>Description</TableHeaderCell>
            <TableHeaderCell>Supported mimetypes</TableHeaderCell>
            <TableHeaderCell>Max size</TableHeaderCell>
            <TableHeaderCell>Expiry</TableHeaderCell>
            <TableHeaderCell>Downloadable</TableHeaderCell>
          </tr>
        </thead>
        <tbody>{purposesList.map((purpose) => FilePurpose(purpose))}</tbody>
      </Table>
    </div>
  );
};
